import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Switch from 'Components/Atoms/Switch/Switch';
import ContactEditorDrawerDefaultValuesFormVerifactu from './ContactEditorDrawerDefaultValuesFormVerifactu';
import ContactEditorDrawerDefaultValuesFormTicketBAI from './ContactEditorDrawerDefaultValuesFormTicketBAI';
import Loading from 'Components/Atoms/Loading/Loading';

export default function ContactEditorDrawerDefaultValuesForm({
    enabled,
    setEnabled,
    values,
    onChangeValue,
    isLoading,
    taxAuthority,
}) {
    const { t } = useTranslation('invoices');

    if (isLoading) {
        return (
            <div className="flex justify-center py-6">
                <Loading />
            </div>
        );
    }

    const Form =
        taxAuthority === 'verifactu'
            ? ContactEditorDrawerDefaultValuesFormVerifactu
            : ContactEditorDrawerDefaultValuesFormTicketBAI;

    return (
        <div>
            <label className="inline-flex gap-4 items-start mb-3 cursor-pointer">
                <div className="py-1">
                    <Switch checked={enabled} onCheckedChange={setEnabled} />
                </div>
                <div>
                    <div className="text-dark-blue font-medium mb-0.5 text-sm">{t('verifactu-default-values')}</div>
                    <div className="text-xs text-gray-500">{t(`${taxAuthority}-default-values-description`)}</div>
                </div>
            </label>
            {enabled && (
                <div className="pl-12">
                    <Form values={values} onChangeValue={onChangeValue} />
                </div>
            )}
        </div>
    );
}

ContactEditorDrawerDefaultValuesForm.propTypes = {
    enabled: PropTypes.bool.isRequired,
    setEnabled: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    onChangeValue: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    taxAuthority: PropTypes.string.isRequired,
};
